import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

interface PolicyLayoutProps {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}

export default function PolicyLayout({ title, lastUpdated, children }: PolicyLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 to-slate-900 text-slate-200">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-indigo-400 mb-8 transition-colors"
        >
          <ArrowLeft size={16} />
          Back to Home
        </Link>

        <h1 className="text-3xl font-bold mb-2 text-slate-100">{title}</h1>
        <p className="text-sm text-slate-500 mb-8">Last updated: {lastUpdated}</p>

        <div className="space-y-6">{children}</div>

        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-sm text-slate-500 text-center">
            StatioPrint by StatioMart |{' '}
            <a href="mailto:info@statiomart.com" className="text-indigo-400 hover:underline">
              info@statiomart.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
